import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { Typography, Button } from '@material-ui/core'

import clsx from 'clsx'
import PreviewAndDownload from './PreviewAndDownload'
import endpoints from 'app/effects/apis/endpointConfig'
import Assets from 'app/configs/assetConfigs'
import { usePlace } from 'commons/usePlace'
import template from './DownloadTemplate.png'

const QRcode = ({ placeName, placeLogo }) => {
  const place = usePlace()
  const { formatMessage } = useIntl()

  // const appName = useAppName()
  // const { logo: appLogo } = useAppLogo()

  const [open, setOpen] = useState(false)
  const [logo, setLogo] = useState('')

  // const fetchOpeningHours = useMutation({
  //   mutationFn: async () => {
  //     const response = await effects.apis.profileInfo.getOpeningHours()
  //     return response.data
  //   },
  //   onError: (error) => {
  //     const msgError = error.response.data
  //     dispatch(MessageAlert.showNetworkError(formatMessage)(msgError))
  //   },
  // })

  //   const handleInitialData = useCallback((data) => {
  //     const raw = raws(data)
  //     setRaw(raw)
  //     setInitialValues(handleInitialValues(raw))
  //   }, [])

  //   useEffect(() => {
  //     if (fetchOpeningHours.isSuccess) handleInitialData(fetchOpeningHours.data)
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [fetchOpeningHours.isSuccess])

  //   useEffect(() => {
  //     fetchOpeningHours.mutate()
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [])
  const [qrVersion, setQrVersion] = useState(new Date().valueOf())

  // const tmpLogo = usePlaceLogo()
  useEffect(() => {
    setLogo(placeLogo ? placeLogo + '?v=' + qrVersion : null)
  }, [placeLogo, qrVersion])
  let backgroundUrl = template //Assets.qr.template
  const openModal = () => {
    setOpen(true)
    setQrVersion(new Date().valueOf())
  }
  return (
    <>
      <div className="bg-white p-10 border-1 border-primary-350 rounded-5 rounded-tr-5 overflow-x-auto">
        <div className="flex justify-between items-center">
          <Typography className="text-14 font-500 text-primary items-center flex">
            {formatMessage({
              id: 'qr.button.second',
            })}
          </Typography>
        </div>
        <div className="mt-4 space-y-2">
          <Button
            className={clsx(
              'p-0 text-secondary text-14 font-400 normal-case disabled:text-grey-200 hover:bg-transparent text-nowrap',
            )}
            onClick={openModal}
            // disabled={isLoadingList || isSubmiitingComment}
          >
            <div className="flex space-x-3 mt-3">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.125 4.875V7.125H4.875V4.875H7.125ZM8.25 3.75H3.75V8.25H8.25V3.75ZM7.125 10.875V13.125H4.875V10.875H7.125ZM8.25 9.75H3.75V14.25H8.25V9.75ZM13.125 4.875V7.125H10.875V4.875H13.125ZM14.25 3.75H9.75V8.25H14.25V3.75ZM9.75 9.75H10.875V10.875H9.75V9.75ZM10.875 10.875H12V12H10.875V10.875ZM12 9.75H13.125V10.875H12V9.75ZM9.75 12H10.875V13.125H9.75V12ZM10.875 13.125H12V14.25H10.875V13.125ZM12 12H13.125V13.125H12V12ZM13.125 10.875H14.25V12H13.125V10.875ZM13.125 13.125H14.25V14.25H13.125V13.125ZM15.75 5.25C15.3375 5.25 15 4.9125 15 4.5V3H13.5C13.0875 3 12.75 2.6625 12.75 2.25C12.75 1.8375 13.0875 1.5 13.5 1.5H15.75C16.1625 1.5 16.5 1.8375 16.5 2.25V4.5C16.5 4.9125 16.1625 5.25 15.75 5.25ZM16.5 15.75V13.5C16.5 13.0875 16.1625 12.75 15.75 12.75C15.3375 12.75 15 13.0875 15 13.5V15H13.5C13.0875 15 12.75 15.3375 12.75 15.75C12.75 16.1625 13.0875 16.5 13.5 16.5H15.75C16.1625 16.5 16.5 16.1625 16.5 15.75ZM2.25 16.5H4.5C4.9125 16.5 5.25 16.1625 5.25 15.75C5.25 15.3375 4.9125 15 4.5 15H3V13.5C3 13.0875 2.6625 12.75 2.25 12.75C1.8375 12.75 1.5 13.0875 1.5 13.5V15.75C1.5 16.1625 1.8375 16.5 2.25 16.5ZM1.5 2.25V4.5C1.5 4.9125 1.8375 5.25 2.25 5.25C2.6625 5.25 3 4.9125 3 4.5V3H4.5C4.9125 3 5.25 2.6625 5.25 2.25C5.25 1.8375 4.9125 1.5 4.5 1.5H2.25C1.8375 1.5 1.5 1.8375 1.5 2.25Z"
                  fill="#00B2AD"
                />
              </svg>
              <Typography>
                {formatMessage({
                  id: 'profile.download.qr.code',
                })}
              </Typography>
            </div>

            {/* {formatMessage(
              {
                id: 'qr.button.second',
              },
              { defaultValue: 'Download QR Code' },
            )} */}
          </Button>
        </div>
      </div>
      {/* {console.log('placeName', placeName)}
      {console.log('placeLogo', placeLogo)}
      {console.log('backgroundUrl', backgroundUrl)} */}

      <PreviewAndDownload
        open={open}
        onClose={() => setOpen(false)}
        // classes={classes}
        placeName={placeName}
        backgroundImageURL={backgroundUrl}
        placeLogoImageURL={logo}
        qrCodeImageURL={endpoints.qr({
          placeId: place.id,
          version: qrVersion,
        })}
      />
    </>
  )
}

export default QRcode
